import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
@Injectable({
    providedIn: 'root'
  })
  export class OrganizationService {
  
    identityUrl: string = environment.api.identity;
  
    constructor(private http: HttpClient) { }

    getOrganizationById(id: string): any{
      return this.http.get(`${this.identityUrl}/organization/${id}`);
    }

    update(id: string, data: any): any{
      return this.http.put(`${this.identityUrl}/organization/update/${id}`, data);
    }
  }
  